// extracted by mini-css-extract-plugin
module.exports = {"project-form-modal":"styles_project-form-modal__1NSls","projectFormModal":"styles_project-form-modal__1NSls"};